import { formatMoney } from 'uses/useShopify'
import { useMemo } from 'preact/hooks'
import { Fragment } from 'preact'

function Price({ className = '', price = 0, originalPrice = null, discountedPrice = null, quantity = 1, classSize = 'text-sm', classColor = '', variants, isGst = false }) {
  const customClass = `price ${className}`
  const isDiscounted = discountedPrice && discountedPrice < price * quantity
  const isSale = originalPrice && originalPrice !== 0 && originalPrice > price
  const colorSalePrice = isSale ? `${classSize} ${classColor}` : `${classSize}`
  const isOnlyVariantDefault = variants && variants.length === 1 && variants[0].title === 'Default Title'
  const finalPrice = isDiscounted ? discountedPrice : price * quantity

  const variantsPrice = useMemo(() => {
    return variants && [...new Set(variants.map(variant => variant.price))]
  }, [])
  return (
    <Fragment>
      {isOnlyVariantDefault ? (
        <div className={customClass}>
          {isDiscounted && <span className={`text-default line-through ${classSize}`}>{formatMoney(price * quantity)}</span>}
          {isSale && !isDiscounted ? <span className={`text-default line-through ${classSize}`}>{formatMoney(originalPrice * quantity)}</span> : ''}
          <span className={colorSalePrice}>{formatMoney(finalPrice)}{isGst && '(Inc. GST)'}</span>
        </div>
      ) : (
        <div className={customClass}>
          {isDiscounted && <span className={`text-default line-through ${classSize}`}>{formatMoney(price * quantity)}</span>}
          {isSale && !isDiscounted ? <span className={`text-default line-through ${classSize}`}>{formatMoney(originalPrice * quantity)}</span> : ''}
          <span className={colorSalePrice}>{variants !== undefined && variantsPrice && variantsPrice.length > 1 ? 'From' : ''} {formatMoney(finalPrice)}{isGst && '(Inc. GST)'}</span>
        </div>
      )}
    </Fragment>
  )
}

export default Price
